import { render, staticRenderFns } from "./TheRoles.vue?vue&type=template&id=3375ef86&"
import script from "./TheRoles.vue?vue&type=script&lang=ts&"
export * from "./TheRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports